<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="size"
    :height="size"
    viewBox="0 0 10 6"
    class="animate-rotate"
    :class="{rotate_inner: rotate}"
    fill="none">
    <path d="M1 1L5 5L9 1" :stroke="fill" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>

<script>
export default {
  name: "ChevronDownIcon",
  props: {
    fill: {
      type: String,
      default: '#1C1C1C'
    },
    size: {
      type: Number,
      default: 10
    },
    rotate: {
      type: Boolean,
      default: false
    }
  }
}
</script>
